import React, { Component } from "react"
import PropTypes from "prop-types"
import FlowValuationWithoutLeadForm from "./FlowValuationWithoutLeadForm"
import FlowValuationOrLeadFormWhenValuationFails from "./FlowValuationOrLeadFormWhenValuationFails"
import FlowValuationThenLeadForm from "./FlowValuationThenLeadForm"
import FlowLeadFormWithoutValuation from "./FlowLeadFormWithoutValuation"
import FlowLeadFormThenValuation from "./FlowLeadFormThenValuation"

class TradeInFlowSelector extends Component {
  render() {
    const {
      props: { flowName },
    } = this

    const componentsMap = {
      ValuationWithoutLeadForm: FlowValuationWithoutLeadForm,
      ValuationOrLeadFormWhenValuationFails:
        FlowValuationOrLeadFormWhenValuationFails,
      ValuationThenLeadForm: FlowValuationThenLeadForm,
      LeadFormWithoutValuation: FlowLeadFormWithoutValuation,
      LeadFormThenValuation: FlowLeadFormThenValuation,
    }

    let FlowComponent = componentsMap[flowName]

    return (
      <div>
        <FlowComponent {...this.props} />
      </div>
    )
  }
}

TradeInFlowSelector.propTypes = {
  flowName: PropTypes.string,
}

export default TradeInFlowSelector
